import { render, staticRenderFns } from "./DealTags.vue?vue&type=template&id=6c05ca23&"
import script from "./DealTags.vue?vue&type=script&lang=js&"
export * from "./DealTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports